import { BasicTrackingEvent } from "./BasicTrackingEvent";
import * as trackingEvents from "@goodgamestudios/tracking-event-types";

export class InvitationTrackingEvent extends BasicTrackingEvent {

    private _playerId: number;

    private _senderPlayerId: number;
    private _senderInstanceId: number;
    private _senderNetworkId: number;
    private _senderGameId: number;
    private _senderExternalId: string;
    private _senderLevel: number;

    private _receiverPlayerId: number;
    private _receiverInstanceId: number;
    private _receiverNetworkId: number;
    private _receiverGameId: number;
    private _receiverExternalId: string;

    private _action: string;
    private _referMethod: string;
    private _trigger: string;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): trackingEvents.Invitation.Event {
        const vars: trackingEvents.Invitation.Event = {
            eventId: trackingEvents.Invitation.ID,
            action: this._action,
            sender_game_id: this._senderGameId,
            sender_instance_id: this._senderInstanceId,
            sender_network_id: this._senderNetworkId,
            sender_player_id: this._senderPlayerId,
        };

        // optional fields
        if (this._senderLevel == 0) {
            vars.sender_level = this._senderLevel;
        }
        if (this._receiverGameId != 0) {
            vars.receiver_game_id = this._receiverGameId;
        }
        if (this._receiverNetworkId != 0) {
            vars.receiver_network_id = this._receiverNetworkId;
        }
        if (this._receiverInstanceId != 0) {
            vars.receiver_instance_id = this._receiverInstanceId;
        }
        if (this._receiverPlayerId != 0) {
            vars.receiver_player_id = this._receiverPlayerId;
        }

        if (this._referMethod) {
            vars.refer_method = this._referMethod;
        }
        if (this._trigger) {
            vars.trigger = this._trigger;
        }
        if (this._senderExternalId) {
            vars.external_inviter_id = this._senderExternalId;
        }
        if (this._receiverExternalId) {
            vars.external_invited_id = this._receiverExternalId;
        }
        return vars;
    }

    public set senderGameId(value: number) {
        this._senderGameId = value;
    }

    public set senderNetworkId(value: number) {
        this._senderNetworkId = value;
    }

    public set senderInstanceId(value: number) {
        this._senderInstanceId = value;
    }

    public set senderPlayerId(value: number) {
        this._senderPlayerId = value;
    }

    public set receiverGameId(value: number) {
        this._receiverGameId = value;
    }

    public set receiverNetworkId(value: number) {
        this._receiverNetworkId = value;
    }

    public set receiverInstanceId(value: number) {
        this._receiverInstanceId = value;
    }

    public set receiverPlayerId(value: number) {
        this._receiverPlayerId = value;
    }

    public set senderExternalId(value: string) {
        this._senderExternalId = value;
    }

    public set receiverExternalId(value: string) {
        this._receiverExternalId = value;
    }

    public set senderLevel(value: number) {
        this._senderLevel = value;
    }

    public set action(value: string) {
        this._action = value;
    }

    public set referMethod(value: string) {
        this._referMethod = value;
    }

    public set trigger(value: string) {
        this._trigger = value;
    }

    public set playerId(value: number) {
        this._playerId = value;
    }
}
